import script from "./TranslatePage.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslatePage.vue?vue&type=script&setup=true&lang=js"

import "./TranslatePage.vue?vue&type=style&index=0&id=7e7b51de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e7b51de"]])

export default __exports__